import { render, staticRenderFns } from "./BannerNoticias.vue?vue&type=template&id=e6c05292&scoped=true&lang=pug"
import script from "./BannerNoticias.vue?vue&type=script&lang=js"
export * from "./BannerNoticias.vue?vue&type=script&lang=js"
import style0 from "./BannerNoticias.vue?vue&type=style&index=0&id=e6c05292&prod&lang=scss&scoped=true"
import style1 from "./BannerNoticias.vue?vue&type=style&index=1&id=e6c05292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c05292",
  null
  
)

export default component.exports